import axios from 'axios'
import { API_VERSION } from '../hooks/useAxios'
import { Safety } from '../classes/Safety'
import { trySessionRefresh } from './auth'

/**
 * Fetch an authenticated API file (a PDF, the payment file, a CSV) and hand it to
 * the browser as a download. Resolves to false when the request failed.
 */
export async function downloadFile(url: string, filename: string): Promise<boolean> {
  const fetchBlob = (token: string | null) => axios({
    url: `/api/${API_VERSION}${url}`,
    responseType: 'blob',
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  })

  let blob: Blob
  try {
    blob = (await fetchBlob(Safety.get('token'))).data
  } catch (err) {
    if (!axios.isAxiosError(err) || err.response?.status !== 401) return false
    const token = await trySessionRefresh()
    if (!token) return false
    try {
      blob = (await fetchBlob(token)).data
    } catch {
      return false
    }
  }

  const href = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = href
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(href), 10_000)
  return true
}
